export const getArticlePath = (link: string): string => {
  return stripAfterNumbers(link.split('/').slice(-2).join('/'))
}

function stripAfterNumbers(input: string): string {
  return input.replace(/(\d+).*$/, '$1')
}
